











































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath } from '@/app/model/store/domain/const'
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import agrinoteImgApi from '@/app/model/api/getAgrinoteImg'

@Component({
  components: {
    Loading
  }
})
export default class GraphMainImageModal extends Vue {
  private slide: number = 0
  private agrinoteOriginalData: string = ''
  private showImgLoading: boolean = true

  private get showMainImgModal (): any {
    return this.$store.state.setFlagState.agrinoteMainImgFlag
  }

  @Watch('showMainImgModal')
  onChangeModal (flag: boolean) {
    if (flag) {
      this.getAgrinoteImg(this.$store.state.fieldDetailsState.agrinoteImgId)
    }
  }

  private getAgrinoteImg (ids: number) {
    (async () => {
      this.showImgLoading = true
      let imgType = 'original'
      let imagePath = []

      let imgId = ids
      let body: any = {
        id: imgId,
        type: imgType
      }
      const result = await agrinoteImgApi.getAgrinoteImg(body)
      let img = result
      this.agrinoteOriginalData = img
      this.showImgLoading = false
    })()
  }

  private closeModal () {
    this.$store.commit('setFlagState/setAgrinoteMainImgFlag', false)
    this.agrinoteOriginalData = ''
    this.$emit('close-modal')
  }
}
